export const GLOBAL = {
	// MODE: import.meta.env.MODE,
	API_URL: process.env.API_URL,
	BASE_API_URL: process.env.BASE_API_URL,
	BASE_API_URL_V3: process.env.API_URL_V3,
	IS_ENABLE_MOCKS: process.env.IS_ENABLE_MOCKS === 'true',
	REACT_ENV: process.env.REACT_ENV,
	SENTRY_URL: process.env.SENTRY_URL,
	GA_KEY: process.env.GA_KEY,
	FB_PIXEL_ID: '2334909273553851',
};
